import {useMutation} from "@tanstack/react-query";

import {createMaterialFunctionMutationOptions} from "./create-material-function.mutation-options";

export function useCreateMaterialFunction() {
  return useMutation(createMaterialFunctionMutationOptions());
}
